import axios from 'axios';
import {app} from '../../acclaro';

// this is only meant to be used for the ReviewRequestForm given its
// dependency on the particular store.
const isUniqueEmail = (email) => {
  
    // form state from module
    let accountId = app.$store.state.ReviewFormStore.onBehalfAccount.id;
  
    return axios.get(
        '/review/reviewer/check-email', {
            params: {
                email,
                accountId
            }
        }
    ).then(
        result => {
            let {error, error_msg} = result.data.data;
        if (error.length) {
            return error_msg;
        }
        return true;
        }
    )
  
};

export { isUniqueEmail };
